<template>
  <div class="containerTable" style="padding: 15px;">
    <orderDetailList :is-statistics="1" />
  </div>
</template>

<script>
  import orderDetailList from "@/views/financialStatistics/profitFee/components/orderDetailList";
  export default {
    name: "Index",
    components:{
      orderDetailList
    },
    data() {
      return {

      }
    },
    created() {

    },
    methods: {

    }
  }

</script>

<style scoped>

</style>
